// @flow
import React from 'react';
import type { ChildrenArray, Element } from 'react';
import styles from './FacetGroupAllFacetsOverlay.css';
import Overlay from './Overlay';
import ResetActiveFacetsByGroupButton from '../facet/ResetActiveFacetsByGroupButton';

type OwnProps = {
  isVisible: boolean,
  hideModal: Function,
  title: Element<any> | string,
  children?: ChildrenArray<Element<any>>,
  selectedFacetIds: Array<number | string | boolean>,
  location: Object,
  type: string | null,
  onClickClear: Function,
};

type Props = OwnProps;

const FacetGroupAllFacetsOverlay = ({
  isVisible,
  hideModal,
  title,
  children,
  selectedFacetIds,
  location,
  type,
  onClickClear,
}: Props) => {
  const { pathname, query } = location;

  const ResetButton = () => {
    if (!type || !selectedFacetIds.length) {
      return null;
    }

    return (
      <ResetActiveFacetsByGroupButton
        type={type}
        pathname={pathname}
        query={query}
        onClickClear={onClickClear}
      />
    );
  };

  return (
    <Overlay
      isVisible={isVisible}
      onClose={hideModal}
      title={title}
      navigation={<ResetButton />}
      transparentOverlay
      animationDirection="left"
      contentLabel="facet-group-all-facets-overlay"
      data-test="facet.group.all-facets-overlay"
    >
      <div className={styles.overlay}>{children}</div>
    </Overlay>
  );
};

export default FacetGroupAllFacetsOverlay;
